import React, { useEffect, useState } from "react";
import { Button } from "@kui-react/button";
import { ProductListContext } from "../../context/ProductListContext";
import specValue from "../../i18n/spec-value.json";
function ItemGridView({ item, theme, currency, etailCall, productInfo, buttonText, ViewDetails, CategoryValue, categoryArr, locale, setOpenRetailDetail, setRetailProductObject, setRetailProductTitle }) {
  let productState = React.useContext(ProductListContext);
  const { activeTab } = productState;
  let price = item.productPrice.replace("$", "")?.split(".");
  // let oldPrice = item.productMSRP.replace("$", "")?.split(".");
  // let subValue1 = item.productMSRP.replace("$", "").replace(",", "");
  // let subValue2 = item.productPrice.replace("$", "").replace(",", "");
  // let subResult = (parseFloat(subValue1) - parseFloat(subValue2)).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  const brandstore = document.getElementById("nvidia_brandstore_widget");
  const brandstoreId = atob(brandstore.getAttribute("data-brandstore-id"));
  // const location = useLocation();
  // const urlParams = new URLSearchParams(location.search);

  // const currencyConvertor = (PriceValue) => {
  //   var currency = {
  //     "BR": {
  //       "Region": "pt-BR",
  //       "Currency": "BRL"
  //     },
  //     "AR":
  //     {
  //       "Region": "es-ar",
  //       "Currency": "ARS"
  //     },
  //     "UK": {
  //       "Region": "en-gb",
  //       "Currency": "GBP"
  //     },
  //     "US": {
  //       "Region": "en-US",
  //       "Currency": "USD"
  //     },
  //     "EN-US": {
  //       "Region": "en-US",
  //       "Currency": "USD"
  //     },
  //     "CA": {
  //       "Region": "en-US",
  //       "Currency": "USD"
  //     },
  //     "MX": {
  //       "Region": "es-mx",
  //       "Currency": "MXN"
  //     },
  //     "AU": {
  //       "Region": "en-au",
  //       "Currency": "AUD"
  //     },
  //     "PH": {
  //       "Region": "en-US",
  //       "Currency": "PHP"
  //     },
  //     "KR": {
  //       "Region": "ko-KR",
  //       "Currency": "KRW"
  //     },
  //     "DE": {
  //       "Region": "de-de",
  //       "Currency": "EUR"
  //     },
  //     "ES": {
  //       "Region": "es-ES",
  //       "Currency": "EUR"
  //     },
  //     "CZ": {
  //       "Region": "cs-CZ",
  //       "Currency": "CZK"
  //     },
  //     "FR": {
  //       "Region": "fr-FR",
  //       "Currency": "EUR"
  //     }

  //   }
  //   try {
  //     var _m = PriceValue.replace("$", "").replace(",", "");
  //     _m = new Intl.NumberFormat(currency[locale]?.Region, {
  //       style: 'currency',
  //       currency: currency[locale].Currency,
  //       minimumFractionDigits: 2
  //     }).format(_m);
  //     return _m;
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }
  const specConvertor = (value, valueType) => {
    value = value.toLowerCase();
    const ocIndex = value?.indexOf('oc mode:');
    const gamingIndex = value.indexOf('gaming mode:');
    const gamingPart = value.slice(gamingIndex + 12).trim();
    if (ocIndex !== -1 && gamingIndex !== -1) {
      const ocPart = value.slice(ocIndex + 9, gamingIndex).trim();
      return valueType === 'ocMode' ? ocPart.toUpperCase() : gamingPart.toUpperCase()
    } else {
      return valueType === 'ocMode' ? value.toUpperCase() : null
    }
  }
  // Function for sorting the product specification
  const [data, setData] = useState([]);
  const customSortOrder = {
    "GPU": [
      "gpu",
      "gpu_memory_type",
      "gpu_memory_size",
      "gpu_boost_clock_speed"],
    "LAPTOP": [
      "screen_size",
      "gpu",
      "processor",
      "ram",
      "hdd_size"
    ],
    "DESKTOP": [
      "gpu",
      "processor",
      "ram",
      "hdd_size",
      "cooling_system"
    ],
    "STUDIO_DESKTOP": [
      "gpu",
      "processor",
      "ram",
      "hdd_size",
      "cooling_system"
    ],
    "MONITOR": [
      "screen_size",
      "monitor_type"
    ],
    "STUDIO-LAPTOP": [
      "gpu",
      "processor",
      "ram",
      "hdd_size",
      "screen_size"
    ],
    "SHIELD_ACCESSORIES": [
      "gpu",
      "processor",
      "ram",
      "hdd_size",
      "screen_size"
    ]
  };
  const compareCustomOrder = (a, b) => {
    const aIndex = customSortOrder[(item?.category).toUpperCase()]?.indexOf(a.name);
    const bIndex = customSortOrder[(item?.category).toUpperCase()]?.indexOf(b.name);
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  };
  const onproductClick = (item) => {
   // let nvidiaFound = false;
    if (item.retailers.length > 0) {
      item.retailers.forEach(retailer => {
        if ((retailer.purchaseLink && retailer.purchaseLink.includes('marketplace.nvidia.com'))||(retailer.purchaseLink && retailer.purchaseLink.includes('store.nvidia.com'))) {
          const purchaseLink = retailer.purchaseLink;
          // window.open(purchaseLink, '_blank');
          window.location.href = purchaseLink;
          //nvidiaFound = true;
        }
      });
    }
    // if(!nvidiaFound){
    //   setOpenRetailDetail(true);
    //   setRetailProductObject(item.retailers);
    //   setRetailProductTitle(item.productTitle);
    // }
  }
  useEffect(() => {
    if (item?.productInfo) setData(item?.productInfo.sort(compareCustomOrder));
    // eslint-disable-next-line
  }, [item]);
  const getValueByName = (name) => {
    const item = data.find((item) => item.name === name);
    return item.value === null ? '' : item.value;
  };
  const launchTracking = (productName) => {
    if (window.ClickOmniProd) {
      // window.ClickOmniProd(this, 'event10,event2', 'button:buy now:', productName, '');
      window.ClickOmniProd(this, "event10,scAdd", "button:section:add to cart:", productName, '');
    }
  };
  let iconHtml = <span className="nv-arrowContainer">
    <svg viewBox="0 0 30 30" data-testid="kui-icon" fill="#eee" height="12" width="12">
      <defs>
        <path d="M7.25 30a1.05 1.05 0 01-.896-.468c-.523-.584-.467-1.168.168-1.753l14.453-12.74L6.522 2.299c-.635-.585-.69-1.17-.168-1.754.56-.663 1.12-.721 1.68-.175l15.518 13.734c.299.233.448.545.448.935s-.15.701-.448.935L8.035 29.708c-.262.195-.523.292-.785.292z" id="arrow-caret-right-solid_svg__a"></path>
      </defs>
      <use xlinkHref="#arrow-caret-right-solid_svg__a" fillRule="evenodd"></use>
    </svg>
  </span>
  return (
    <div
      className={`${activeTab?.name === "Home" || activeTab?.name === "SHIELD" ? "nv-col-3" : "nv-col-4"} border-right-bottom`}
      key={item.id}
    >
      <div className="image-wrapper">


        <div style={{ visibility: item?.offerText && brandstoreId === '22' ? 'visible' : 'hidden' }} className="nV_OfferBox">
          <div className="nV_OfferPercentBox">
            <span className="nV_percentTxt">-{item?.offerText}</span>
          </div>
        </div>   

        <a
          href={item?.retailers[0]?.directPurchaseLink ? item?.retailers[0]?.directPurchaseLink : item?.productUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => { etailCall("PDP_CLICK", item?.retailers[0]?.directPurchaseLink);; onproductClick(item) }}>
          <img
            className={"card-img-top" + (theme === "dark" ? " overlay " : "")}
            src={item.imageURL}
            alt={item.productTitle + "image"}
            loading="lazy"
          /></a>
      </div>
      <div className="card-body">
        <div className="custom-tooltip">
          <a className="card-title"
            href={item?.retailers[0]?.directPurchaseLink ? item?.retailers[0]?.directPurchaseLink : item?.productUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => { etailCall("PDP_CLICK", item?.retailers[0]?.directPurchaseLink);; onproductClick(item) }}>
            <h2>{item.productTitle}</h2>

          </a>
          <div className="nv-ProductSpecification">
            {
              // eslint-disable-next-line
              data?.slice(0, 2).map((info, index) => {
                let SpecificationObject = {};
                try {
                  if (info.name === "specification") {
                    // eslint-disable-next-line
                    SpecificationObject = JSON.parse(info.value)
                    //  console.log(SpecificationObject)
                  }
                } catch (error) {
                  //  console.log(CategoryValue + error);
                }
                const ProductSpec = specValue[locale]
                const ProductSpecField = ProductSpec[(item?.category).toUpperCase()]
                try {
                  return info?.name && info?.name?.length > 2 && ProductSpecField[info?.name] ? (
                    <div className="card-info" key={info?.name + index} style={{ display: info?.value ? 'block' : 'None' }}>

                      {ProductSpecField["" + info?.name + ""] ? <>
                        {ProductSpecField === "ram" ? <>{iconHtml}<p className="nv-spec-container"><span>{ProductSpecField["" + info?.name + ""]}</span><span>: {info.value ? info.value : '--'}</span></p></> : null}

                        {/* {info?.name === "gpu_memory_type" && getValueByName('gpu_memory_size') && getValueByName('gpu_memory_type') ? <>{iconHtml}<p className="nv-spec-container"><span>{ProductSpecField["" + info?.name + ""]}</span>: {getValueByName('gpu_memory_size') + ' ' + getValueByName('gpu_memory_type')}</p></> : null} */}
                        {info?.name === "hdd_size" && getValueByName('hdd_size') && getValueByName('hdd_type') ? <>{iconHtml}<p className="nv-spec-container"><span>{ProductSpecField["" + info?.name + ""]}</span>: {getValueByName('hdd_size') + ' ' + getValueByName('hdd_type')}</p></> : null}
                        {info?.name === "screen_size" && getValueByName('screen_size') && getValueByName('screen_resolution') && getValueByName('monitor_type') ? <>{iconHtml}<p className="nv-spec-container"><span>{ProductSpecField["" + info?.name + ""]}</span>: {getValueByName('screen_size') + '|' + getValueByName('screen_resolution') + getValueByName('monitor_type')}</p></> : null}


                        {info?.name === "gpu_boost_clock_speed" ? <>{iconHtml}<p className="nv-spec-container"><span>{ProductSpecField["" + info?.name + ""]}</span><span>: {info.value && specConvertor(info.value, 'ocMode') ? specConvertor(info.value, 'ocMode') : '--'}</span></p></> : null}
                        {info?.name === "ai_power_graphic_tech" ? <>{iconHtml} <p className="nv-spec-container">{info.value}</p></> : null}
                        {info?.name === "gpu_boost_clock_speed" ? <><div style={{ padding: "8px 0 0 0", display: info?.value?.includes('Gaming mode:') ? 'block' : 'None' }}>
                          <span>
                            <svg viewBox="0 0 30 30" data-testid="kui-icon" fill="#8bc34a" height="12" width="12">
                              <defs>
                                <path d="M7.25 30a1.05 1.05 0 01-.896-.468c-.523-.584-.467-1.168.168-1.753l14.453-12.74L6.522 2.299c-.635-.585-.69-1.17-.168-1.754.56-.663 1.12-.721 1.68-.175l15.518 13.734c.299.233.448.545.448.935s-.15.701-.448.935L8.035 29.708c-.262.195-.523.292-.785.292z" id="arrow-caret-right-solid_svg__a"></path>
                              </defs>
                              <use xlinkHref="#arrow-caret-right-solid_svg__a" fillRule="evenodd"></use>
                            </svg>
                          </span><span>Gaming mode</span><span>: {info.value && specConvertor(info.value, 'gamingMode') ? specConvertor(info.value, 'gamingMode') : '--'}</span></div></> : null}
                        {info?.name !== "gpu_boost_clock_speed"
                          // && info?.name !== "gpu_memory_type"
                          && info?.name !== "hdd_size"
                          && info?.name !== "screen_resolution"
                          && info?.name !== "screen_size"
                          && info?.name !== "monitor_type"
                          && info?.name !== "ai_power_graphic_tech"
                          && <>{iconHtml}<p className="nv-spec-container"><span>{ProductSpecField["" + info?.name + ""]}</span><span>: {info.value ? info?.value?.replace('&quot;', '"').replace(/RTX/g, 'GeForce RTX').replace(/GTX/g, 'GeForce GTX') : '--'}</span></p></>}   </> : null}
                    </div>
                  ) : null;
                } catch (error) {
                  console.log(error)
                }

              }
              )}
          </div>
        </div>
        {/* <div className="fullRow relativeDiv">
          <div className="align-middle background-white">
            {brandstoreId === '22' || brandstoreId === '345' ? <div className="nV_cell pull-left"><div className="nV_emproduct_artnum">{item?.productSKU}</div></div> : null}
          </div>
          <div className="nV_emproduct_review">
          </div></div> */}
          
          <div className="nv-container-label">
          <label className="nV_price">
            {/* {brandstoreId === '397' ? currency + price[0] : currencyConvertor(item.productPrice)} */}
            {currency + price[0]}.<span className="nv-after-digit-price">{price[1]}</span>
          </label>


          <Button
            className="btn-availability"
            // href={item?.retailers[0]?.directPurchaseLink ? item?.retailers[0]?.directPurchaseLink : item?.productUrl}
            // target="_blank"
            onClick={() => { etailCall("BUY_NOW", item?.productUrl); onproductClick(item);launchTracking(item?.productTitle); }}
          >
            {item?.productAvailable ? buttonText : ViewDetails}
          </Button>
          </div>
      </div>
    </div>

  );
}

export default ItemGridView;
